const dateExtract = (date) => {
    return(`${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`)
} 

export {dateExtract}